var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contents"},_vm._l((_vm.contents),function(content){return _c('div',{key:content.key,staticClass:"content"},[_c('div',{class:[
        'content__text',
        !content.unClickable && 'content__text--clickable'
      ],on:{"click":function($event){return _vm.onClickContent(content.key, content.name)}}},[_c('OccHeading',{attrs:{"level":3,"color":"gray","weight":"medium"}},[_vm._v(" "+_vm._s(content.name)+" ")]),(content.errorCount)?_c('OccTag',{attrs:{"label":String(content.errorCount),"type":"badge","color":"alert"}}):_vm._e()],1),_c('div',{staticClass:"content__subContents"},_vm._l((content.subContents),function(subContent){return _c('div',{key:subContent.key,on:{"click":function($event){return _vm.onClickSubContent(
            content.key,
            subContent.key,
            content.name,
            subContent.name
          )}}},[_c('OccHeading',{class:[
            'subContent',
            !subContent.unClickable && 'subContent--clickable'
          ],attrs:{"level":4,"color":subContent.invalid
              ? 'alert'
              : subContent.disabled
              ? 'light'
              : 'gray',"weight":"medium"}},[_vm._v(" "+_vm._s(subContent.name || "-")+" ")])],1)}),0)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }